import React, { useEffect } from "react";
import Main from "../../../Main/Main";
import Tabs from "../../Tabs/Tabs";
import Details from "../../Details/Details";
import DetailsData from "./DetailsFinanceData";
function Finance({ title }) {
  useEffect(() => {
    document.title = title;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [title]);
  return (
    <div>
      <Main
        heading="Finance"
        description="Gain efficiency through our fintech development solutions"
      />
      <Tabs active="5" />
      <Details data={DetailsData} />
    </div>
  );
}

export default Finance;
